import { usePortal } from '@/contexts/PortalContext'

/**
 * The reCAPTCHA site key for the domain the page is ACTUALLY served from.
 *
 * A Google site key is bound to a domain list. Ours is registered for siluxmobile.co.uk,
 * so rendering it on a reseller's *.mobileflow.uk page makes the widget draw Google's
 * "ERROR for site owner: Invalid domain for site key" box instead of a challenge — which
 * is exactly what a Lyra visitor saw in the footer newsletter form. The backend has had a
 * separate portal key pair configured all along (RECAPTCHA_PORTAL_SITE_KEY / _SECRET_KEY)
 * and serves the site half on /portal/config; nothing on the front end was reading it.
 *
 * On a portal we therefore use ONLY the portal key. If one is not configured we return an
 * empty string so the caller can skip the widget rather than trap the visitor behind a
 * challenge that can never be solved.
 *
 * Keyed off `isPortal` (the detected subdomain) rather than the loaded config, because the
 * config arrives a moment after first paint — keying off `portal` would render the main
 * key, and its invalid-domain error, for that first moment.
 */
export function useRecaptchaSiteKey(): string {
  const { portal, isPortal } = usePortal()
  if (isPortal) return portal?.recaptcha_site_key || ''
  return import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''
}
